// eslint-disable-next-line import/prefer-default-export
export const AddressType = {
  HOME: 'HOME',
  WORK: 'WORK',
};
